import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoadingScreenComponent } from '../components/loading-screen/loading-screen.component';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private activeRequests = 0;
  private loaderDialogRef: MatDialogRef<LoadingScreenComponent> = null;
  public isLoadingSubject = new BehaviorSubject<boolean>(false);

  constructor(private dialog: MatDialog) {
  }

  get isLoading$(): Observable<boolean> {
    return this.isLoadingSubject.asObservable();
  }

  show() {
    this.activeRequests++;
    if (!this.loaderDialogRef) {
      this.loaderDialogRef = this.dialog.open(LoadingScreenComponent, {
        disableClose: true,
        hasBackdrop: true,
        autoFocus: false,
        restoreFocus: false,
        panelClass: 'global-spinner-dialog',
        backdropClass: 'global-spinner-backdrop'
      });
    }
    this.isLoadingSubject.next(true);
  }

  hide() {
    this.activeRequests--;
    if (this.activeRequests <= 0) {
      this.activeRequests = 0;
      if (this.loaderDialogRef) {
        this.loaderDialogRef.close();
        this.loaderDialogRef = null;
      }
      this.isLoadingSubject.next(false);
    }
  }
}
